import React, { Component } from 'react';
import { QueryRenderer } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import { Button, FormControl, FormControlLabel, Grid, InputLabel, Link, ListItemIcon, ListItemText, 
         Menu, MenuItem, Paper, Select, Switch, 
         TableContainer, Table, TableHead, TableCell, TableBody, TablePagination, TableRow, 
         TextField, Tooltip, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PartnerFetch from './PartnerFetch';

import { ArrowDropDown, CheckCircle, Cancel, Construction, Edit, Error, PendingActions, ZoomIn } from '@mui/icons-material';
import { red, green, grey } from '@mui/material/colors';

import CurrencyTextField from '../ui/CurrencyTextField';
import ServerError from '../ui/ServerError';
import PageTitle from '../ui/PageTitle';
import ConfirmationDialog from '../ui/ConfirmationDialog';
import PayoutStatusChangeDialog from './PayoutStatusChangeDialog';
import AdHocCommissionDialog from './AdHocCommissionDialog';
import LoadingSpinner from '../ui/LoadingSpinner';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';

import PayoutUpdateMutation from './PayoutUpdateMutation';
import PayoutStatusRejectMutation from './PayoutStatusRejectMutation';

import { addDays, addMonths, endOfDay, format, isValid, startOfDay, subDays, subMonths } from 'date-fns';

const abEnvironment = new AbEnvironment();

const PayoutQuery = graphql`
query PayoutLinesQuery($vendorAccountId: UUID!, $resellername: String, $unapprovedOnly: Int, $startts: Datetime, $endts: Datetime, $first: Int, $offset: Int) {
  getpayoutlines(vendoraccountid: $vendorAccountId, resellername: $resellername, unapprovedonly: $unapprovedOnly, startts: $startts, endts: $endts,  first: $first, offset: $offset) {
    totalCount
    nodes {
      vendorPayoutId
      resellerAccountId
      resellerAccountName
      programName
      cpId
      description
      programType
      payoutDate
      startTs
      endTs
      chargeAmountTotal
      payoutAmount
      approvedBy
      approvedTime
      status
      statusReason
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  },
  paper: {
    maxWidth: 1200,
    marginTop: '16px'
  },
  icon: {
    width: 22,
    height: 22
  },
  statusEl: {
    paddingRight: 12,
    paddingLeft: 12
  }
});

class Payout extends Component {
  constructor(props) {
    super(props);


    let payoutToDate = new Date();
    let tDate = localStorage.getItem('payoutToDate');
    if (tDate != null) {
      payoutToDate = new Date(tDate);
    }
    //search todate should be "start of next day"
    let searchToDateUtc = startOfDay(addDays(payoutToDate, 1)).toISOString();

    let payoutFromDate = new Date();
    let fDate = localStorage.getItem('payoutFromDate');
    if (fDate != null) {
      payoutFromDate = new Date(fDate);
    } else {
      payoutFromDate = subMonths(payoutToDate, 1);
    }
    //search todate should be "start of next day"
    let searchFromDateUtc = startOfDay(payoutFromDate).toISOString();

    this.state = {
      accountName: '',
      unapprovedOnly:  0,
      startDate: payoutFromDate,
      queryStartDateUtc: searchFromDateUtc,
      endDate: payoutToDate,
      queryEndDateUtc: searchToDateUtc,
      approveConfirm: false,
      rejectConfirm: false,
      payoutToApprove: null,
      statusReason: '',
      anchorEl: null,
      reFetch: 0,
      page: 0,
      rowsPerPage: 10,
      showCommissionDialog: false,
      adHocCommissionAmount: 0,
      partners: [],
      selectedPartnerId: null,
      partnersLoaded: false,
      adHocCommissionReason: ''
    };  
  }

  componentDidMount() {
    let accountSearchTerm = localStorage.getItem('pAccountName');
  
    if (accountSearchTerm == null)
    accountSearchTerm = '';

    //if localstorage has "show approved", set the state and remove from the local storage after first load.
    let { unapprovedOnly } = this.state.unapprovedOnly;

    if (localStorage.getItem('payoutShowApproved') === 'true') {
      unapprovedOnly = 1;
    } else if (unapprovedOnly == null || localStorage.getItem('payoutShowApproved') === 'false') {
      unapprovedOnly = 0;
    }

    let theVendorAccountId = abEnvironment.getUserAttribute('a_id');
    PartnerFetch.fetch(theVendorAccountId).toPromise()
    .then(pf => {
      let thePartners = [];
      for (let i = 0; i < pf.accountTByAccountId.accountRelationTsByAccountId.nodes.length; i++) {
        let aPartner = pf.accountTByAccountId.accountRelationTsByAccountId.nodes[i];
        thePartners.push({partnerId: aPartner.relatedId, partnerName: aPartner.accountTByRelatedId.accountName});
      }

      thePartners.sort(function(a, b) {
        let aStr = '' + a.partnerName;
        let bStr = '' + b.partnerName;
        return aStr.localeCompare(bStr);
      });

      let selectedPartnerId = null;
      if (thePartners.length > 0) {
        selectedPartnerId = thePartners[0].partnerId;
      }

      this.setState({partnersLoaded: true, partners: thePartners, selectedPartnerId: selectedPartnerId, accountName: accountSearchTerm, unapprovedOnly: unapprovedOnly});
    })
    .catch(err => {
      //nothing to do....
      alert('err: ' + JSON.stringify(err));
      this.setState({partnersLoaded: true, partners: [], selectedPartnerId: null, accountName: accountSearchTerm, unapprovedOnly: unapprovedOnly});
    });
  }

  goTo(route) {
    localStorage.setItem('pAccountName', this.state.accountName);
 
    this.props.history.push(`/${route}`);
  }

  confirmApproval(payoutId) {
    this.setState({
      approveConfirm: true,
      payoutToApprove: payoutId,
      anchorEl: null,
    });
  }
  
  confirmReject(payoutId) {
    //a little wierd reusing the payoutToApprove state but for convenience.
    this.setState({
      rejectConfirm: true,
      payoutToApprove: payoutId,
      anchorEl: null
    });
  }
  
  handleMenuClose = () => {
    this.setState({anchorEl: null});
  }
  handleMenuClick = event => {
    this.setState({anchorEl: event.currentTarget});
  }

  showDetail(payoutId, resellerId) {
    if (payoutId) {
      let url = 'payoutdetail?vendorPayoutId=' + payoutId;
      this.props.history.push(`/${url}`);
    } else {
      //Instant payout type
      let startDate = this.state.queryStartDateUtc;
      let endDate = this.state.queryEndDateUtc;
      let url = 'payoutdetailinstant?resellerId=' + resellerId + '&start=' + startDate + '&end=' + endDate;
      this.props.history.push(`/${url}`);
    }
  }

  //if we want to include cpId as return value for payout lines, then can re-direct to the edit page.
  showVendorCommissionProgram(cpId) {
    if (cpId) {
      let url = 'vendorcommprogramedit?fp=payouts&cpId=' + cpId;
      this.props.history.push(`/${url}`);
    }
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }
  
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  setFromDate(theDate) {
    let vdate = new Date(theDate);
    if (isValid(vdate)) {
      localStorage.setItem('payoutFromDate', theDate);
      let searchDateUtc = startOfDay(vdate).toISOString()
      this.setState({ startDate: theDate, queryStartDateUtc: searchDateUtc, page : 0 });
    }
  }

  setToDate(theDate) {
    let vdate = new Date(theDate);
    if (isValid(vdate)) {
      localStorage.setItem('payoutToDate', theDate);
      let searchDateUtc = startOfDay(addDays(vdate, 1)).toISOString()
      this.setState({ endDate: theDate, queryEndDateUtc: searchDateUtc, page : 0 });
    }
  }

  getProgramTypeText(type) {

    if (type === 0) {
      return "Instant rebate";
    } else if (type === 1) {
      return "Monthly rebate";
    } else if (type === 2) {
      return "Monthly credits";
    } else if (type === 3) {
      return "Prepaid credits";
    } else if (type === 4) {
      return "Referral";
    } else if (type === 5) {
      return "One-time payout"
    } else {
      return "Unknown";
    }
  }

  getProgramStatusElement(status) {
    const classes = this.props.classes;
    const cancelColor = red[300];
    const okColor = green[300];
    const pendingColor = grey[300];

    switch (status) {
      case 0: {
        return "Pending";
      } case 1: {
        return <Tooltip title='Approved' className={classes.statusEl}><CheckCircle htmlColor={okColor} /></Tooltip>;
      } case 2: {
        return <Tooltip title='Transferring funds' className={classes.statusEl}><CheckCircle htmlColor={okColor} /></Tooltip>;
      } case 3: {
        return <Tooltip title='Transferring funds' className={classes.statusEl}><CheckCircle htmlColor={okColor} /></Tooltip>;
      } case 4: {
        return <Tooltip title='Paid' className={classes.statusEl}><CheckCircle htmlColor={okColor} /></Tooltip>;
      } case 5: {
        return <Tooltip title='Not approved' className={classes.statusEl}><Cancel htmlColor={cancelColor} /></Tooltip>;
      } case 6: {
        return <Tooltip title='Reversed' className={classes.statusEl}><Construction htmlColor={pendingColor} /></Tooltip>;
      } case 12: {
        return <Tooltip title='Error in transfer' className={classes.statusEl}><Error htmlColor={cancelColor} /></Tooltip>;
      } case 13: {
        return <Tooltip title='Error in transfer' className={classes.statusEl}><Error htmlColor={cancelColor} /></Tooltip>;
      } default:
        return "Unknown";
    }
  }

  render() {
    const { isAuthenticated, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    const cancelColor = red[300];
    const okColor = green[300];
    const pendingColor = grey[500];

    let theAccountSearch = null;
    if (this.state.accountName !== '') {
      theAccountSearch = '%' + this.state.accountName + '%';
    }
 
    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;
  
    let totalCount = 0;
    let rowCount = 0;

    // Experiences for different personas...
    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    } else if (isAuthenticatedVendor()) {
      if (this.state.partnersLoaded === false) {
        return (
          <div>
            <Typography>Loading...</Typography>
            <LoadingSpinner/>
          </div>
        );
      }

      let theVendorAccountId = abEnvironment.getUserAttribute('a_id');

      return (
        <main>
          <PageTitle title="Payouts" subtitle="View payouts and review / approve pending payouts."/>

          <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center" style={{marginBottom: 8}}>
            <Grid item>
              <Grid container spacing={1} direction="row" justifyContent="flex-start">
                <Grid item>
                  <SearchField
                    id="accountName"
                    label="Search by partner account name"
                    value={this.state.accountName}
                    onChange={this.handleChange('accountName')}
                  />
                </Grid>
                
                <Grid item>
                  <FormControlLabel style={{marginTop: '16px'}}
                    control={
                      <Switch
                        checked={this.state.unapprovedOnly === 1}
                        onChange={(e, checked) => {
                          if (checked) {
                            localStorage.setItem('payoutShowApproved', 'true');
                            this.setState({ unapprovedOnly: 1, page: 0});
                          } else {
                            localStorage.setItem('payoutShowApproved', 'false');
                            this.setState({ unapprovedOnly: 0, page: 0});
                          }
                        }}
                      />
                    }
                    label="Show unapproved only"
                  />
                </Grid>

                {this.state.unapprovedOnly === 0 &&
                <React.Fragment>
                  <Grid item>
                    <div style={AppBindStyles.datePickerField}>
                    <DatePicker
                      maxDateMessage={AppBindStyles.datePickerMessageMax}
                      autoOk
                      label="From date"
                      value={this.state.startDate}
                      onChange={(date) => this.setFromDate(date) }
                      format="YYYY-MM-DD"
                      disableFuture
                      renderInput={(params) => <TextField {...params} />}
                    />
                    </div>
                  </Grid>
                  <Grid item>
                    <div style={AppBindStyles.datePickerField}>
                    <DatePicker
                      maxDateMessage={AppBindStyles.datePickerMessageMax}
                      autoOk
                      label="To date"
                      value={this.state.endDate}
                      onChange={(date) => this.setToDate(date) }
                      format="YYYY-MM-DD"
                      disableFuture
                      renderInput={(params) => <TextField {...params} />}
                    />
                    </div>
                  </Grid>
                </React.Fragment>
                }
              </Grid>
            </Grid>
            <Grid item>
              <Button color="primary" variant="outlined" size="small" 
                      onClick={() => {this.setState({showCommissionDialog:true});}}>
                Create one-time payout
              </Button>
            </Grid>
          </Grid>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={PayoutQuery}
            variables={{vendorAccountId: theVendorAccountId,
                        resellername: theAccountSearch,
                        unapprovedOnly: this.state.unapprovedOnly,
                        startts: this.state.queryStartDateUtc,
                        endts: this.state.queryEndDateUtc,
                        forceFetch: this.state.reFetch,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                // Determine offset information
                totalCount = props.getpayoutlines.totalCount;

                let payouts = props.getpayoutlines.nodes;

                let adHocCommissionAmountString = Number(this.state.adHocCommissionAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

                return ( 
                  <span className={classes.paper} style={{marginTop:24}}>
                  <Paper >
                  <TableContainer>
                    <Table>
                      <TableHead style={AppBindStyles.tableHead}>
                        <TableRow style={AppBindStyles.tableHeadRow}>
                          <TableCell>Date</TableCell>
                          <TableCell>Partner</TableCell>
                          <TableCell>Plan name</TableCell>
                          <TableCell>Program type</TableCell>
                          <TableCell align="right">Sold</TableCell>
                          <TableCell align="right">Earned</TableCell>
                          <TableCell align='center'>View</TableCell>
                          <TableCell align='right'>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>

                      {payouts.map(n => {

                        let aUrl = "resellervendor?accountId=" + n.resellerAccountId + '&fp=Payouts';
                        let vendorPayoutId = n.vendorPayoutId;
                        
                        //times are "timestamap without timezone"; from is start of month, end is start next month.
                        //  this is range, start date no translation to UTC, end date "minus day, end of day"
                        let startOfRange = format(new Date(n.startTs), 'yyyy-MM-dd');
                        let endOfRange = format(endOfDay(subDays(new Date(n.endTs), 1)), 'yyyy-MM-dd');
                        
                        let theRangeDescription = 'Transactions from ' + startOfRange + ' through ' + endOfRange;
                        if (n.programType === 5) {
                          theRangeDescription = 'One-time rebate payout on ' + startOfRange;
                        }

                        let totalSold = '';
                        if (n.chargeAmountTotal > 0) {
                          totalSold = Number(n.chargeAmountTotal).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                        }

                        let totalEarned = Number(n.payoutAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                        if (n.status === 6) {
                          totalEarned = Number(0).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                        }

                        let totalPayout = Number(n.payoutAmount);
                        let statusElement = this.getProgramStatusElement(n.status);

                        return (
                          <TableRow key={rowCount++}>
                            {/* <TableCell>{n.programType === 0 ? dateRange : pdate}</TableCell> */}
                            { n.programType === 0 &&
                              <TableCell>{endOfRange}</TableCell>
                            }
                            { n.programType !== 0 &&
                              <TableCell><Tooltip title={theRangeDescription}><div>{endOfRange}</div></Tooltip></TableCell>
                            }
                            <TableCell>
                              <Link component="button" 
                                    variant="body2"
                                    onClick={this.goTo.bind(this, aUrl)}>
                                {n.resellerAccountName}
                              </Link>
                            </TableCell>
                            { n.programType !== 5 &&
                            <TableCell align="left">
                              <Tooltip title={n.description}>
                                <Link component="button" 
                                  variant="body2"
                                  onClick={() => this.showVendorCommissionProgram(n.cpId) }>
                                    {n.programName}
                                </Link>
                              </Tooltip>
                            </TableCell>}
                            { n.programType === 5 &&
                            <TableCell align="left">
                            </TableCell>}
                            <TableCell>{this.getProgramTypeText(n.programType)}</TableCell>
                            <TableCell align="right">{totalSold}</TableCell>
                            <TableCell align="right">{totalEarned}</TableCell>
                            {n.status !== 0 &&
                            <React.Fragment>
                              <TableCell align="center">
                                <Button
                                  color="primary"
                                  onClick={() => {
                                    this.showDetail(vendorPayoutId, n.resellerAccountId)
                                    }}>
                                  <ZoomIn  className={classes.icon}/>
                                </Button>
                              </TableCell>
                              <TableCell align='right'>
                                {statusElement}
                              </TableCell>
                            </React.Fragment>
                            }
                            {n.status === 0 &&
                              <React.Fragment>
                                <TableCell align="center">
                                  <Tooltip title="Approve individual subscriptions">
                                  <Button
                                    color="primary"
                                    onClick={() => {
                                      this.showDetail(vendorPayoutId, n.resellerAccountId)
                                      }}>
                                    <Edit className={classes.editicon}/>
                                  </Button>
                                  </Tooltip>
                                </TableCell>
                                <TableCell align='right' >
                                  <Tooltip title="Pending">
                                    <Button style={{ paddingRight:0, marginRight:-6 }}
                                      aria-owns={this.state.anchorEl ? 'simple-menu': undefined}
                                      aria-haspopup='true'
                                      onClick={this.handleMenuClick}
                                      className={classes.statusButton}>
                                      <PendingActions htmlColor={pendingColor} className={classes.icon}/>
                                      <ArrowDropDown />
                                    </Button>
                                  </Tooltip>
                         
                                  <Menu
                                    id="action-menu"
                                    anchorEl={this.state.anchorEl}
                                    open={Boolean(this.state.anchorEl)}
                                    onClose={this.handleMenuClose}>

                                    { totalPayout > 0 &&
                                    <MenuItem onClick={() => { this.confirmApproval(vendorPayoutId); }}>
                                      <ListItemIcon>
                                        <CheckCircle htmlColor={okColor} />
                                      </ListItemIcon>
                                      <ListItemText primary="Approve"/>
                                    </MenuItem>
                                    } 
                                    <MenuItem onClick={() => { this.confirmReject(vendorPayoutId); }}>
                                      <ListItemIcon>
                                        <Cancel htmlColor={cancelColor} />
                                      </ListItemIcon>
                                      <ListItemText primary="Reject"/>
                                    </MenuItem>
                                  </Menu>
                                </TableCell>                               
                              </React.Fragment>
                            }
                          </TableRow>
                        );
                      })}
                      </TableBody>
                    </Table>
                    </TableContainer>
                    <ConfirmationDialog
                          open={this.state.approveConfirm}
                          onClose={() => { this.setState({approveConfirm:false, anchorEl: null});}}
                          onConfirm={() => {this._approvePayout() }}
                          onCancel={() => { }}
                          title="Approve payout?"
                          cancelBtn="Cancel"
                          okBtn="Ok"
                          irreversibleAction={true}
                        >
                          If you proceed, this payout will be approved.
                    </ConfirmationDialog>  
 
                    <PayoutStatusChangeDialog
                      open={this.state.rejectConfirm}
                      onClose={() => { this.setState({rejectConfirm:false, statusReason: '', anchorEl: null});}}
                      onConfirm={() => { this._rejectPayout()}}
                      onCancel={() => { this.setState({rejectConfirm:false, statusReason: '', anchorEl: null});}}
                      statusReason={this.state.statusReason}
                      title="Reject payout?"
                      cancelBtn="Cancel"
                      okBtn="Ok">
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                           <Typography variant="body1">
                           If you proceed, this payout will be marked as rejected, and will not be paid.  Please provide a reason.
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            id="status-reason" label="Reason for reject" 
                            value={this.state.statusReason}
                            fullWidth
                            multiline
                            onChange={(e) => this.setState({ statusReason: e.target.value })}
                            inputProps={{ maxLength: 1064 }} />
                        </Grid>
                      </Grid>
                    </PayoutStatusChangeDialog>

                    <AdHocCommissionDialog
                      open={this.state.showCommissionDialog}
                      onClose={() => { this.setState({showCommissionDialog:false}); }}
                      onConfirm={() => { this._processAdHocPayout() }}
                      onCancel={() => { this.setState({showCommissionDialog:false}); }}
                      title={'Create one-time commission payout'}
                      cancelBtn="Cancel"
                      editBtn={false}
                      okBtn={"Commission " + adHocCommissionAmountString + " now"}
                      okDisabled={this._disableAdHocPayout()}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <FormControl variant="standard" >
                            <InputLabel htmlFor={'Partner'} >{'Partner'}</InputLabel>
                            <Select
                              value={ this.state.selectedPartnerId }
                              className={classes.form}
                              onChange={(e) => { 
                                  this.setState({ selectedPartnerId: e.target.value }); 
                              } }
                              inputProps={{
                                name: 'formId',
                                id: 'formId',
                              }}
                            >      
                              { this.state.partners.map(n => {       
                                return (<MenuItem key={n.partnerId} value={n.partnerId}>{n.partnerName}</MenuItem>);
                              })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <CurrencyTextField 
                            id="payout-amount" label="Payout amount"
                            value={this.state.adHocCommissionAmount}
                            onChange={ (e) => this.setState({ adHocCommissionAmount: e.target.value }) }
                            showErrMsg={true}
                            allowNegative={false}
                            minValue={1}
                            minEnterValue={0}
                            maxValue={9999}
                            maxEnterValue={9999}
                            textAlign="right"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            id="payout-reason" label="Reason for payout"
                            value={this.state.adHocCommissionReason}
                            fullWidth
                            multiline
                            onChange={(e) => this.setState({ adHocCommissionReason: e.target.value })}
                            inputProps={{ maxLength: 1024 }} />
                        </Grid>
                      </Grid>
                    </AdHocCommissionDialog>
                      
                  </Paper>
                  <div style={AppBindStyles.paginationTableFooter}>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={totalCount}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      backIconButtonProps={{
                      'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                      'aria-label': 'Next Page',
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                  </div>
                </span>
                )
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </main>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }

  _disableAdHocPayout = () => {
    if (this.state.selectedPartnerId == null) {
      return true;
    }
    if (this.state.adHocCommissionReason == null || this.state.adHocCommissionReason.length < 1) {
      return true;
    }
    if (this.state.adHocCommissionAmount >= 1) {
      return false;
    }
    return true;
  }

  _processAdHocPayout = () => {
    const { callPartnerApi } = this.props.auth;

    let thePJwt = abEnvironment.getPjwt();
    let theVendorAccountId = abEnvironment.getUserAttribute("a_id");

    let payload = {
      operation: "createOneOffVendorPayout",
      params: {
        pJwt:              thePJwt,
        vendorAccountId:   theVendorAccountId,
        resellerAccountId: this.state.selectedPartnerId,
        amount:            this.state.adHocCommissionAmount,
        reason:            this.state.adHocCommissionReason
      }
    };

    callPartnerApi('appbind/generic',
                    'POST',
                    payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(json => {
      let fetchCount = this.state.reFetch;
      fetchCount++;
      this.setState({ reFetch: fetchCount, showCommissionDialog:false});
    })
    .catch(err => {
      // console.log(err);
      this.setState({ showCommissionDialog:false});
    });
  }

  _approvePayout = () => {
    const { callPartnerApi } = this.props.auth;
 
    let userId = abEnvironment.getUserAttribute("u_id");
    let accountId = abEnvironment.getUserAttribute("a_id");
    let now = new Date();
    let nowString = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate() + ' ' + now.getUTCHours() + ':' + now.getUTCMinutes() + ':00';

    PayoutUpdateMutation.commit(this.state.payoutToApprove,  1, userId, nowString)
    .then(response => {
      //initiate vendor payout.  This backend API will insert
      //an SQS message to start it.

     let payload = {
       operation: "startVendorPayout",
       params: {
         accountId: accountId,
         payoutId: this.state.payoutToApprove

       }
     };
 
     return callPartnerApi('appbind/generic',
                    'POST',
                    payload)
    }).then(resp => {
     return resp.json();
    }).then(response => {
      let fetchCount = this.state.reFetch;
      fetchCount++;
      this.setState({ reFetch: fetchCount });
    })
    .catch(error => {
      // console.log('Got error: ' + error);
    });
  }

  _rejectPayout = () => {
    let userId = abEnvironment.getUserAttribute("u_id");
    let accountId = abEnvironment.getUserAttribute("a_id");

    PayoutStatusRejectMutation.commit(accountId, this.state.payoutToApprove,  userId, this.state.statusReason)
    .then(response => {
      let fetchCount = this.state.reFetch;
      fetchCount++;
      this.setState({ reFetch: fetchCount, statusReason: '' });
    })
    .catch(error => {
      // console.log('Got error: ' + error);
    });
  }

}

Payout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Payout);
